<template>
  <div class="bank-icon-list">
    <div v-if="banks.length > 0" class="banks-grid">
      <div
          v-for="bank in banks"
          :key="bank.key"
          class="bank-item"
          @click="selectBank(bank.key)"
      >
        <img
            :src="getBankIcon(bank.icon)"
            :alt="bank.name"
            class="bank-icon"
        />
        <div class="bank-name">{{ bank.name }}</div>
      </div>
    </div>
    <div v-else class="no-banks">
      No banks available
    </div>
  </div>
</template>

<script>
export default {
  name: "BankIconList",
  props: {
    banks: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    selectBank(key) {
      this.$emit("onSelect", key);
    },
    getBankIcon(iconPath) {
      try {
        // return require(`@/assets/${iconPath}`);
        return new URL(`../assets/${iconPath}`, import.meta.url).href;
      } catch (e) {
        // return require("@/assets/images/default-bank.png");
        return new URL(`@/assets/images/default-bank.png`, import.meta.url).href;
      }
    },
  },
};
</script>

<style scoped>
.bank-icon-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 16px;
}

.banks-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 16px;
  width: 100%;
}

.bank-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s ease;
}


.bank-item:hover {
  transform: scale(1.05);
}

.bank-icon {
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin-bottom: 8px;
}

.bank-name {
  font-size: 14px;
  text-align: center;
}

.no-banks {
  font-size: 16px;
  color: #888;
}
</style>
